import {Selectors} from "@core/store/selectors";
import {isAdmin} from "@util";
import {ReactNode} from "react";
import {useSelector} from "react-redux";

const Admin = ({children}: {children: ReactNode}) => {
  const role = useSelector(Selectors.userRole);

  if (role && isAdmin(role)) {
    return <>{children}</>;
  }

  return <></>;
};

export {Admin};
